import { render, staticRenderFns } from "./NewDashboard.vue?vue&type=template&id=369c76c2"
import script from "./NewDashboard.vue?vue&type=script&lang=ts"
export * from "./NewDashboard.vue?vue&type=script&lang=ts"
import style0 from "./NewDashboard.vue?vue&type=style&index=0&id=369c76c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports